import { Component, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

const _c0 = function (a0) { return { "active": a0 }; };
function CronEditorComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 9)(1, "a", 10);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_1_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.setActiveTab("minutes")); });
    ɵngcc0.ɵɵtext(2, " Minutes ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r0.activeTab === "minutes"));
} }
function CronEditorComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 12);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_2_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17.setActiveTab("hourly")); });
    ɵngcc0.ɵɵtext(2, " Hourly ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r1.activeTab === "hourly"));
} }
function CronEditorComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 13);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_3_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r19.setActiveTab("daily")); });
    ɵngcc0.ɵɵtext(2, " Daily ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r2.activeTab === "daily"));
} }
function CronEditorComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 14);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_4_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r21.setActiveTab("weekly")); });
    ɵngcc0.ɵɵtext(2, " Weekly ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r3.activeTab === "weekly"));
} }
function CronEditorComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 15);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_5_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r23.setActiveTab("monthly")); });
    ɵngcc0.ɵɵtext(2, " Monthly ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r4.activeTab === "monthly"));
} }
function CronEditorComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 16);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_6_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r25.setActiveTab("yearly")); });
    ɵngcc0.ɵɵtext(2, " Yearly ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r5.activeTab === "yearly"));
} }
function CronEditorComponent_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11)(1, "a", 17);
    ɵngcc0.ɵɵlistener("click", function CronEditorComponent_li_7_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r27.setActiveTab("advanced")); });
    ɵngcc0.ɵɵtext(2, " Advanced ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r6.activeTab === "advanced"));
} }
function CronEditorComponent_div_12_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const minute_r32 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", minute_r32);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", minute_r32, " ");
} }
function CronEditorComponent_div_12_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "on second");
    ɵngcc0.ɵɵelementEnd();
} }
function CronEditorComponent_div_12_select_7_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const second_r34 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", second_r34);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", second_r34, " ");
} }
function CronEditorComponent_div_12_select_7_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 25);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_12_select_7_Template_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r35.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_12_select_7_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r37.state.minutes.seconds = $event); });
    ɵngcc0.ɵɵtemplate(1, CronEditorComponent_div_12_select_7_option_1_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r31.disabled || ctx_r31.activeTab !== "minutes")("ngModel", ctx_r31.state.minutes.seconds)("ngClass", ctx_r31.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r31.selectOptions.seconds);
} }
function CronEditorComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " Every ");
    ɵngcc0.ɵɵelementStart(3, "select", 20);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_12_Template_select_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r38.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_12_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r40.state.minutes.minutes = $event); });
    ɵngcc0.ɵɵtemplate(4, CronEditorComponent_div_12_option_4_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " minute(s) ");
    ɵngcc0.ɵɵtemplate(6, CronEditorComponent_div_12_span_6_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtemplate(7, CronEditorComponent_div_12_select_7_Template, 2, 4, "select", 23);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c0, ctx_r7.activeTab === "minutes"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r7.disabled || ctx_r7.activeTab !== "minutes")("ngModel", ctx_r7.state.minutes.minutes)("ngClass", ctx_r7.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.selectOptions.minutes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.options.hideSeconds);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.options.hideSeconds);
} }
function CronEditorComponent_div_13_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hour_r45 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", hour_r45);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", hour_r45, " ");
} }
function CronEditorComponent_div_13_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const minute_r46 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", minute_r46);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", minute_r46, " ");
} }
function CronEditorComponent_div_13_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "and second");
    ɵngcc0.ɵɵelementEnd();
} }
function CronEditorComponent_div_13_select_9_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const second_r48 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", second_r48);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", second_r48, " ");
} }
function CronEditorComponent_div_13_select_9_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 25);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_13_select_9_Template_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r49.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_13_select_9_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r51 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r51.state.hourly.seconds = $event); });
    ɵngcc0.ɵɵtemplate(1, CronEditorComponent_div_13_select_9_option_1_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r44.disabled || ctx_r44.activeTab !== "hourly")("ngModel", ctx_r44.state.hourly.seconds)("ngClass", ctx_r44.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r44.selectOptions.seconds);
} }
function CronEditorComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " Every ");
    ɵngcc0.ɵɵelementStart(3, "select", 26);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_13_Template_select_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r52 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r52.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_13_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r54 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r54.state.hourly.hours = $event); });
    ɵngcc0.ɵɵtemplate(4, CronEditorComponent_div_13_option_4_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " hour(s) on minute ");
    ɵngcc0.ɵɵelementStart(6, "select", 20);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_13_Template_select_change_6_listener() { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r55 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r55.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_13_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r56 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r56.state.hourly.minutes = $event); });
    ɵngcc0.ɵɵtemplate(7, CronEditorComponent_div_13_option_7_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, CronEditorComponent_div_13_span_8_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtemplate(9, CronEditorComponent_div_13_select_9_Template, 2, 4, "select", 23);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c0, ctx_r8.activeTab === "hourly"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r8.disabled || ctx_r8.activeTab !== "hourly")("ngModel", ctx_r8.state.hourly.hours)("ngClass", ctx_r8.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.selectOptions.hours);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r8.disabled || ctx_r8.activeTab !== "hourly")("ngModel", ctx_r8.state.hourly.minutes)("ngClass", ctx_r8.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.selectOptions.fullMinutes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.options.hideSeconds);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.options.hideSeconds);
} }
function CronEditorComponent_div_14_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const monthDay_r58 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", monthDay_r58);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", monthDay_r58, " ");
} }
function CronEditorComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "input", 27);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_14_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r59 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r59.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_14_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r61 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r61.state.daily.subTab = $event); })("change", function CronEditorComponent_div_14_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r62 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r62.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_14_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r63 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r63.state.daily.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, " Every ");
    ɵngcc0.ɵɵelementStart(4, "select", 28);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_14_Template_select_change_4_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r64 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r64.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_14_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r65 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r65.state.daily.everyDays.days = $event); });
    ɵngcc0.ɵɵtemplate(5, CronEditorComponent_div_14_option_5_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " day(s) at ");
    ɵngcc0.ɵɵelementStart(7, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_14_Template_cron_time_picker_change_7_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r66 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r66.regenerateCron()); })("timeChange", function CronEditorComponent_div_14_Template_cron_time_picker_timeChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r67 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r67.state.daily.everyDays = $event); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(8, "div", 19)(9, "input", 30);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_14_Template_input_change_9_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r68 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r68.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_14_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r69 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r69.state.daily.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " Every working day at ");
    ɵngcc0.ɵɵelementStart(11, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_14_Template_cron_time_picker_change_11_listener() { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r70 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r70.regenerateCron()); })("timeChange", function CronEditorComponent_div_14_Template_cron_time_picker_timeChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r71 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r71.state.daily.everyWeekDay = $event); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(23, _c0, ctx_r9.activeTab === "daily"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabled)("ngModel", ctx_r9.state.daily.subTab)("disabled", ctx_r9.disabled)("ngModel", ctx_r9.state.daily.subTab)("ngClass", ctx_r9.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabled || ctx_r9.activeTab !== "daily" || ctx_r9.state.daily.subTab !== "everyDays")("ngModel", ctx_r9.state.daily.everyDays.days)("ngClass", ctx_r9.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.selectOptions.monthDays);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabled || ctx_r9.activeTab !== "daily" || ctx_r9.state.daily.subTab !== "everyDays")("time", ctx_r9.state.daily.everyDays)("selectClass", ctx_r9.options.formSelectClass)("use24HourTime", ctx_r9.options.use24HourTime)("hideSeconds", ctx_r9.options.hideSeconds);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabled)("ngModel", ctx_r9.state.daily.subTab)("ngClass", ctx_r9.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabled || ctx_r9.activeTab !== "daily" || ctx_r9.state.daily.subTab !== "everyWeekDay")("time", ctx_r9.state.daily.everyWeekDay)("selectClass", ctx_r9.options.formSelectClass)("use24HourTime", ctx_r9.options.use24HourTime)("hideSeconds", ctx_r9.options.hideSeconds);
} }
function CronEditorComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r73 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "div", 4)(3, "div", 31)(4, "label", 32)(5, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_5_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r72 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r72.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r74 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r74.state.weekly.MON = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " Monday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(7, "div", 31)(8, "label", 32)(9, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_9_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r75 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r75.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r76 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r76.state.weekly.TUE = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " Tuesday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(11, "div", 31)(12, "label", 32)(13, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_13_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r77 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r77.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r78 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r78.state.weekly.WED = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, " Wednesday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(15, "div", 31)(16, "label", 32)(17, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_17_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r79 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r79.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r80 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r80.state.weekly.THU = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, " Thursday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(19, "div", 31)(20, "label", 32)(21, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_21_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r81 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r81.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r82 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r82.state.weekly.FRI = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(22, " Friday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(23, "div", 31)(24, "label", 32)(25, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_25_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r83 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r83.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_25_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r84 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r84.state.weekly.SAT = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(26, " Saturday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(27, "div", 31)(28, "label", 32)(29, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_input_change_29_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r85 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r85.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_15_Template_input_ngModelChange_29_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r86 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r86.state.weekly.SUN = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(30, " Sunday");
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(31, "div", 4)(32, "div", 31);
    ɵngcc0.ɵɵtext(33, " at ");
    ɵngcc0.ɵɵelementStart(34, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_15_Template_cron_time_picker_change_34_listener() { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r87 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r87.regenerateCron()); })("timeChange", function CronEditorComponent_div_15_Template_cron_time_picker_timeChange_34_listener($event) { ɵngcc0.ɵɵrestoreView(_r73); const ctx_r88 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r88.state.weekly = $event); });
    ɵngcc0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c0, ctx_r10.activeTab === "weekly"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.MON)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.TUE)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.WED)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.THU)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.FRI)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.SAT)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("ngModel", ctx_r10.state.weekly.SUN)("ngClass", ctx_r10.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.disabled || ctx_r10.activeTab !== "weekly")("time", ctx_r10.state.weekly)("selectClass", ctx_r10.options.formSelectClass)("use24HourTime", ctx_r10.options.use24HourTime)("hideSeconds", ctx_r10.options.hideSeconds);
} }
function CronEditorComponent_div_16_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const monthDaysWithLast_r95 = ctx.$implicit;
    const ctx_r89 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", monthDaysWithLast_r95);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r89.monthDayDisplay(monthDaysWithLast_r95), " ");
} }
function CronEditorComponent_div_16_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r96 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", month_r96);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", month_r96, " ");
} }
function CronEditorComponent_div_16_option_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const monthWeek_r97 = ctx.$implicit;
    const ctx_r91 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", monthWeek_r97);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r91.monthWeekDisplay(monthWeek_r97), " ");
} }
function CronEditorComponent_div_16_option_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r98 = ctx.$implicit;
    const ctx_r92 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", day_r98);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r92.dayDisplay(day_r98), " ");
} }
function CronEditorComponent_div_16_option_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r99 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", month_r99);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", month_r99, " ");
} }
function CronEditorComponent_div_16_option_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r100 = ctx.$implicit;
    const ctx_r94 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", month_r100);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r94.monthDisplay(month_r100), " ");
} }
function CronEditorComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r102 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "input", 34);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r101 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r101.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r103 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r103.state.monthly.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, " On the ");
    ɵngcc0.ɵɵelementStart(4, "select", 35);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_4_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r104 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r104.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r105 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r105.state.monthly.specificDay.day = $event); });
    ɵngcc0.ɵɵtemplate(5, CronEditorComponent_div_16_option_5_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " of every ");
    ɵngcc0.ɵɵelementStart(7, "select", 36);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_7_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r106 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r106.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r107 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r107.state.monthly.specificDay.months = $event); });
    ɵngcc0.ɵɵtemplate(8, CronEditorComponent_div_16_option_8_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, " month(s) at ");
    ɵngcc0.ɵɵelementStart(10, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_cron_time_picker_change_10_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r108 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r108.regenerateCron()); })("timeChange", function CronEditorComponent_div_16_Template_cron_time_picker_timeChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r109 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r109.state.monthly.specificDay = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\u00A0 ");
    ɵngcc0.ɵɵelementStart(12, "label", 32)(13, "input", 33);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_input_change_13_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r110 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r110.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r111 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r111.state.monthly.runOnWeekday = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, " during the nearest weekday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(15, "div", 19)(16, "input", 37);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_input_change_16_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r112 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r112.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r113 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r113.state.monthly.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, " On the ");
    ɵngcc0.ɵɵelementStart(18, "select", 38);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_18_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r114 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r114.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r115 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r115.state.monthly.specificWeekDay.monthWeek = $event); });
    ɵngcc0.ɵɵtemplate(19, CronEditorComponent_div_16_option_19_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "select", 39);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_20_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r116 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r116.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_20_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r117 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r117.state.monthly.specificWeekDay.day = $event); });
    ɵngcc0.ɵɵtemplate(21, CronEditorComponent_div_16_option_21_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(22, " of every ");
    ɵngcc0.ɵɵelementStart(23, "select", 36);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_23_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r118 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r118.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r119 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r119.state.monthly.specificWeekDay.months = $event); });
    ɵngcc0.ɵɵtemplate(24, CronEditorComponent_div_16_option_24_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25, " month(s) starting in ");
    ɵngcc0.ɵɵelementStart(26, "select", 40);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_select_change_26_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r120 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r120.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_16_Template_select_ngModelChange_26_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r121 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r121.state.monthly.specificWeekDay.startMonth = $event); });
    ɵngcc0.ɵɵtemplate(27, CronEditorComponent_div_16_option_27_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(28, " at ");
    ɵngcc0.ɵɵelementStart(29, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_16_Template_cron_time_picker_change_29_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r122 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r122.regenerateCron()); })("timeChange", function CronEditorComponent_div_16_Template_cron_time_picker_timeChange_29_listener($event) { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r123 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r123.state.monthly.specificWeekDay = $event); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(44, _c0, ctx_r11.activeTab === "monthly"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled)("ngModel", ctx_r11.state.monthly.subTab)("ngClass", ctx_r11.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificDay")("ngModel", ctx_r11.state.monthly.specificDay.day)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.monthDaysWithLasts);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificDay")("ngModel", ctx_r11.state.monthly.specificDay.months)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.months);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificDay")("time", ctx_r11.state.monthly.specificDay)("selectClass", ctx_r11.options.formSelectClass)("use24HourTime", ctx_r11.options.use24HourTime)("hideSeconds", ctx_r11.options.hideSeconds);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificDay")("ngModel", ctx_r11.state.monthly.runOnWeekday)("ngClass", ctx_r11.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled)("ngModel", ctx_r11.state.monthly.subTab)("ngClass", ctx_r11.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificWeekDay")("ngModel", ctx_r11.state.monthly.specificWeekDay.monthWeek)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.monthWeeks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificWeekDay")("ngModel", ctx_r11.state.monthly.specificWeekDay.day)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.days);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificWeekDay")("ngModel", ctx_r11.state.monthly.specificWeekDay.months)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.months);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificWeekDay")("ngModel", ctx_r11.state.monthly.specificWeekDay.startMonth)("ngClass", ctx_r11.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.selectOptions.months);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.disabled || ctx_r11.activeTab !== "monthly" || ctx_r11.state.monthly.subTab !== "specificWeekDay")("time", ctx_r11.state.monthly.specificWeekDay)("selectClass", ctx_r11.options.formSelectClass)("use24HourTime", ctx_r11.options.use24HourTime)("hideSeconds", ctx_r11.options.hideSeconds);
} }
function CronEditorComponent_div_17_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r129 = ctx.$implicit;
    const ctx_r124 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", month_r129);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r124.monthDisplay(month_r129), " ");
} }
function CronEditorComponent_div_17_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const monthDaysWithLast_r130 = ctx.$implicit;
    const ctx_r125 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", monthDaysWithLast_r130);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r125.monthDayDisplay(monthDaysWithLast_r130), " ");
} }
function CronEditorComponent_div_17_option_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const monthWeek_r131 = ctx.$implicit;
    const ctx_r126 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", monthWeek_r131);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r126.monthWeekDisplay(monthWeek_r131), " ");
} }
function CronEditorComponent_div_17_option_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r132 = ctx.$implicit;
    const ctx_r127 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", day_r132);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r127.dayDisplay(day_r132), " ");
} }
function CronEditorComponent_div_17_option_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r133 = ctx.$implicit;
    const ctx_r128 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", month_r133);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r128.monthDisplay(month_r133), " ");
} }
function CronEditorComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r135 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "input", 41);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r134 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r134.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r136 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r136.state.yearly.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, " Every ");
    ɵngcc0.ɵɵelementStart(4, "select", 40);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_select_change_4_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r137 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r137.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r138 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r138.state.yearly.specificMonthDay.month = $event); });
    ɵngcc0.ɵɵtemplate(5, CronEditorComponent_div_17_option_5_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " on the ");
    ɵngcc0.ɵɵelementStart(7, "select", 35);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_select_change_7_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r139 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r139.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r140 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r140.state.yearly.specificMonthDay.day = $event); });
    ɵngcc0.ɵɵtemplate(8, CronEditorComponent_div_17_option_8_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, " at ");
    ɵngcc0.ɵɵelementStart(10, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_cron_time_picker_change_10_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r141 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r141.regenerateCron()); })("timeChange", function CronEditorComponent_div_17_Template_cron_time_picker_timeChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r142 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r142.state.yearly.specificMonthDay = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\u00A0 ");
    ɵngcc0.ɵɵelementStart(12, "label", 32)(13, "input", 42);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_input_change_13_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r143 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r143.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r144 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r144.state.yearly.runOnWeekday = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, " during the nearest weekday");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(15, "div", 19)(16, "input", 43);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_input_change_16_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r145 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r145.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r146 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r146.state.yearly.subTab = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, " On the ");
    ɵngcc0.ɵɵelementStart(18, "select", 38);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_select_change_18_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r147 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r147.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_select_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r148 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r148.state.yearly.specificMonthWeek.monthWeek = $event); });
    ɵngcc0.ɵɵtemplate(19, CronEditorComponent_div_17_option_19_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "select", 39);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_select_change_20_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r149 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r149.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_select_ngModelChange_20_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r150 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r150.state.yearly.specificMonthWeek.day = $event); });
    ɵngcc0.ɵɵtemplate(21, CronEditorComponent_div_17_option_21_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(22, " of ");
    ɵngcc0.ɵɵelementStart(23, "select", 40);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_select_change_23_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r151 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r151.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_17_Template_select_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r152 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r152.state.yearly.specificMonthWeek.month = $event); });
    ɵngcc0.ɵɵtemplate(24, CronEditorComponent_div_17_option_24_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25, " at ");
    ɵngcc0.ɵɵelementStart(26, "cron-time-picker", 29);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_17_Template_cron_time_picker_change_26_listener() { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r153 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r153.regenerateCron()); })("timeChange", function CronEditorComponent_div_17_Template_cron_time_picker_timeChange_26_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const ctx_r154 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r154.state.yearly.specificMonthWeek = $event); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(39, _c0, ctx_r12.activeTab === "yearly"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled)("ngModel", ctx_r12.state.yearly.subTab)("ngClass", ctx_r12.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthDay")("ngModel", ctx_r12.state.yearly.specificMonthDay.month)("ngClass", ctx_r12.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.selectOptions.months);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthDay")("ngModel", ctx_r12.state.yearly.specificMonthDay.day)("ngClass", ctx_r12.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.selectOptions.monthDaysWithLasts);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthDay")("time", ctx_r12.state.yearly.specificMonthDay)("selectClass", ctx_r12.options.formSelectClass)("use24HourTime", ctx_r12.options.use24HourTime)("hideSeconds", ctx_r12.options.hideSeconds);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.state.yearly.runOnWeekday)("ngClass", ctx_r12.options.formCheckboxClass);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled)("ngModel", ctx_r12.state.yearly.subTab)("ngClass", ctx_r12.state.formRadioClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthWeek")("ngModel", ctx_r12.state.yearly.specificMonthWeek.monthWeek)("ngClass", ctx_r12.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.selectOptions.monthWeeks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthWeek")("ngModel", ctx_r12.state.yearly.specificMonthWeek.day)("ngClass", ctx_r12.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.selectOptions.days);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthWeek")("ngModel", ctx_r12.state.yearly.specificMonthWeek.month)("ngClass", ctx_r12.options.formSelectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r12.selectOptions.months);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.disabled || ctx_r12.activeTab !== "yearly" || ctx_r12.state.yearly.subTab !== "specificMonthWeek")("time", ctx_r12.state.yearly.specificMonthWeek)("selectClass", ctx_r12.options.formSelectClass)("use24HourTime", ctx_r12.options.use24HourTime)("hideSeconds", ctx_r12.options.hideSeconds);
} }
function CronEditorComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r156 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1, " Cron Expression ");
    ɵngcc0.ɵɵelementStart(2, "input", 44);
    ɵngcc0.ɵɵlistener("change", function CronEditorComponent_div_18_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r156); const ctx_r155 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r155.regenerateCron()); })("ngModelChange", function CronEditorComponent_div_18_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r156); const ctx_r157 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r157.state.advanced.expression = $event); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx_r13.activeTab === "advanced"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.state.advanced.expression)("ngClass", ctx_r13.options.formInputClass);
} }
function CronEditorComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4)(1, "code");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.state.validation.errorMessage);
} }
function TimePickerComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hour_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", hour_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(hour_r4);
} }
function TimePickerComponent_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const minute_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", minute_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(minute_r5);
} }
function TimePickerComponent_select_4_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const second_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", second_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(second_r7);
} }
function TimePickerComponent_select_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 0);
    ɵngcc0.ɵɵlistener("change", function TimePickerComponent_select_4_Template_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.change.emit()); })("ngModelChange", function TimePickerComponent_select_4_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.time.seconds = $event); });
    ɵngcc0.ɵɵtemplate(1, TimePickerComponent_select_4_option_1_Template, 2, 2, "option", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.time.seconds)("disabled", ctx_r2.disabled)("ngClass", ctx_r2.selectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.seconds);
} }
function TimePickerComponent_select_5_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hourType_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", hourType_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(hourType_r12);
} }
function TimePickerComponent_select_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 0);
    ɵngcc0.ɵɵlistener("change", function TimePickerComponent_select_5_Template_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.change.emit()); })("ngModelChange", function TimePickerComponent_select_5_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.time.hourTypes = $event); });
    ɵngcc0.ɵɵtemplate(1, TimePickerComponent_select_5_option_1_Template, 2, 2, "option", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.time.hourTypes)("disabled", ctx_r3.disabled)("ngClass", ctx_r3.selectClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.hourTypes);
} }
const Days = {
    'SUN': 'Sunday',
    'MON': 'Monday',
    'TUE': 'Tuesday',
    'WED': 'Wednesday',
    'THU': 'Thursday',
    'FRI': 'Friday',
    'SAT': 'Saturday'
};
/** @type {?} */
const MonthWeeks = {
    '#1': 'First',
    '#2': 'Second',
    '#3': 'Third',
    '#4': 'Fourth',
    '#5': 'Fifth',
    'L': 'Last'
};
/** @enum {number} */
const Months = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
};
Months[Months.January] = 'January';
Months[Months.February] = 'February';
Months[Months.March] = 'March';
Months[Months.April] = 'April';
Months[Months.May] = 'May';
Months[Months.June] = 'June';
Months[Months.July] = 'July';
Months[Months.August] = 'August';
Months[Months.September] = 'September';
Months[Months.October] = 'October';
Months[Months.November] = 'November';
Months[Months.December] = 'December';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class Utils {
    /**
     * This returns a range of numbers. Starts from 0 if 'startFrom' is not set
     * @param {?} startFrom
     * @param {?} until
     * @return {?}
     */
    static getRange(startFrom, until) {
        return Array.from({ length: (until + 1 - startFrom) }, (_, k) => k + startFrom);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CronEditorComponent {
    constructor() {
        // the name is an Angular convention, @Input variable name + "Change" suffix
        this.cronChange = new EventEmitter();
        this.selectOptions = this.getSelectOptions();
    }
    /**
     * @return {?}
     */
    get cron() { return this.localCron; }
    /**
     * @param {?} value
     * @return {?}
     */
    set cron(value) {
        this.localCron = value;
        this.cronChange.emit(this.localCron);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.options.removeSeconds) {
            this.options.hideSeconds = true;
        }
        this.state = this.getDefaultState();
        this.handleModelChange(this.cron);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const newCron = changes['cron'];
        if (newCron && !newCron.firstChange) {
            this.handleModelChange(this.cron);
        }
    }
    /**
     * @param {?} tab
     * @return {?}
     */
    setActiveTab(tab) {
        if (!this.disabled) {
            this.activeTab = tab;
            this.regenerateCron();
        }
    }
    /**
     * @param {?} day
     * @return {?}
     */
    dayDisplay(day) {
        return Days[day];
    }
    /**
     * @param {?} monthWeekNumber
     * @return {?}
     */
    monthWeekDisplay(monthWeekNumber) {
        return MonthWeeks[monthWeekNumber];
    }
    /**
     * @param {?} month
     * @return {?}
     */
    monthDisplay(month) {
        return Months[month];
    }
    /**
     * @param {?} month
     * @return {?}
     */
    monthDayDisplay(month) {
        if (month === 'L') {
            return 'Last Day';
        }
        else if (month === 'LW') {
            return 'Last Weekday';
        }
        else if (month === '1W') {
            return 'First Weekday';
        }
        else {
            return `${month}${this.getOrdinalSuffix(month)} day`;
        }
    }
    /**
     * @return {?}
     */
    regenerateCron() {
        this.isDirty = true;
        switch (this.activeTab) {
            case 'minutes':
                this.cron = `0/${this.state.minutes.minutes} * 1/1 * ?`;
                if (!this.options.removeSeconds) {
                    this.cron = `${this.state.minutes.seconds} ${this.cron}`;
                }
                if (!this.options.removeYears) {
                    this.cron = `${this.cron} *`;
                }
                break;
            case 'hourly':
                this.cron = `${this.state.hourly.minutes} 0/${this.state.hourly.hours} 1/1 * ?`;
                if (!this.options.removeSeconds) {
                    this.cron = `${this.state.hourly.seconds} ${this.cron}`;
                }
                if (!this.options.removeYears) {
                    this.cron = `${this.cron} *`;
                }
                break;
            case 'daily':
                switch (this.state.daily.subTab) {
                    case 'everyDays':
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.daily.everyDays.minutes} ${this.hourToCron(this.state.daily.everyDays.hours, this.state.daily.everyDays.hourType)} 1/${this.state.daily.everyDays.days} * ?`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.daily.everyDays.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    case 'everyWeekDay':
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.daily.everyWeekDay.minutes} ${this.hourToCron(this.state.daily.everyWeekDay.hours, this.state.daily.everyWeekDay.hourType)} ? * MON-FRI`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.daily.everyWeekDay.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    default:
                        throw new Error('Invalid cron daily subtab selection');
                }
                break;
            case 'weekly':
                /** @type {?} */
                const days = this.selectOptions.days
                    .reduce((acc, day) => this.state.weekly[day] ? acc.concat([day]) : acc, [])
                    .join(',');
                this.cron = `${this.state.weekly.minutes} ${this.hourToCron(this.state.weekly.hours, this.state.weekly.hourType)} ? * ${days}`;
                if (!this.options.removeSeconds) {
                    this.cron = `${this.state.weekly.seconds} ${this.cron}`;
                }
                if (!this.options.removeYears) {
                    this.cron = `${this.cron} *`;
                }
                break;
            case 'monthly':
                switch (this.state.monthly.subTab) {
                    case 'specificDay':
                        /** @type {?} */
                        const day = this.state.monthly.runOnWeekday ? `${this.state.monthly.specificDay.day}W` : this.state.monthly.specificDay.day;
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.monthly.specificDay.minutes} ${this.hourToCron(this.state.monthly.specificDay.hours, this.state.monthly.specificDay.hourType)} ${day} 1/${this.state.monthly.specificDay.months} ?`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.monthly.specificDay.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    case 'specificWeekDay':
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.monthly.specificWeekDay.minutes} ${this.hourToCron(this.state.monthly.specificWeekDay.hours, this.state.monthly.specificWeekDay.hourType)} ? ${this.state.monthly.specificWeekDay.startMonth}/${this.state.monthly.specificWeekDay.months} ${this.state.monthly.specificWeekDay.day}${this.state.monthly.specificWeekDay.monthWeek}`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.monthly.specificWeekDay.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    default:
                        throw new Error('Invalid cron monthly subtab selection');
                }
                break;
            case 'yearly':
                switch (this.state.yearly.subTab) {
                    case 'specificMonthDay':
                        // tslint:disable-next-line:max-line-length
                        /** @type {?} */
                        const day = this.state.yearly.runOnWeekday ? `${this.state.yearly.specificMonthDay.day}W` : this.state.yearly.specificMonthDay.day;
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.yearly.specificMonthDay.minutes} ${this.hourToCron(this.state.yearly.specificMonthDay.hours, this.state.yearly.specificMonthDay.hourType)} ${day} ${this.state.yearly.specificMonthDay.month} ?`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.yearly.specificMonthDay.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    case 'specificMonthWeek':
                        // tslint:disable-next-line:max-line-length
                        this.cron = `${this.state.yearly.specificMonthWeek.minutes} ${this.hourToCron(this.state.yearly.specificMonthWeek.hours, this.state.yearly.specificMonthWeek.hourType)} ? ${this.state.yearly.specificMonthWeek.month} ${this.state.yearly.specificMonthWeek.day}${this.state.yearly.specificMonthWeek.monthWeek}`;
                        if (!this.options.removeSeconds) {
                            this.cron = `${this.state.yearly.specificMonthWeek.seconds} ${this.cron}`;
                        }
                        if (!this.options.removeYears) {
                            this.cron = `${this.cron} *`;
                        }
                        break;
                    default:
                        throw new Error('Invalid cron yearly subtab selection');
                }
                break;
            case 'advanced':
                this.cron = this.state.advanced.expression;
                break;
            default:
                throw new Error('Invalid cron active tab selection');
        }
    }
    /**
     * @private
     * @param {?} hour
     * @return {?}
     */
    getAmPmHour(hour) {
        return this.options.use24HourTime ? hour : (hour + 11) % 12 + 1;
    }
    /**
     * @private
     * @param {?} hour
     * @return {?}
     */
    getHourType(hour) {
        return this.options.use24HourTime ? undefined : (hour >= 12 ? 'PM' : 'AM');
    }
    /**
     * @private
     * @param {?} hour
     * @param {?} hourType
     * @return {?}
     */
    hourToCron(hour, hourType) {
        if (this.options.use24HourTime) {
            return hour;
        }
        else {
            return hourType === 'AM' ? (hour === 12 ? 0 : hour) : (hour === 12 ? 12 : hour + 12);
        }
    }
    /**
     * @private
     * @param {?} cron
     * @return {?}
     */
    handleModelChange(cron) {
        if (this.isDirty) {
            this.isDirty = false;
            return;
        }
        else {
            this.isDirty = false;
        }
        this.validate(cron);
        /** @type {?} */
        let cronSeven = cron;
        if (this.options.removeSeconds) {
            cronSeven = `0 ${cron}`;
        }
        if (this.options.removeYears) {
            cronSeven = `${cronSeven} *`;
        }
        const [seconds, minutes, hours, dayOfMonth, month, dayOfWeek] = cronSeven.split(' ');
        if (cronSeven.match(/\d+ 0\/\d+ \* 1\/1 \* \? \*/)) {
            this.activeTab = 'minutes';
            this.state.minutes.minutes = Number(minutes.substring(2));
            this.state.minutes.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ 0\/\d+ 1\/1 \* \? \*/)) {
            this.activeTab = 'hourly';
            this.state.hourly.hours = Number(hours.substring(2));
            this.state.hourly.minutes = Number(minutes);
            this.state.hourly.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ 1\/\d+ \* \? \*/)) {
            this.activeTab = 'daily';
            this.state.daily.subTab = 'everyDays';
            this.state.daily.everyDays.days = Number(dayOfMonth.substring(2));
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.daily.everyDays.hours = this.getAmPmHour(parsedHours);
            this.state.daily.everyDays.hourType = this.getHourType(parsedHours);
            this.state.daily.everyDays.minutes = Number(minutes);
            this.state.daily.everyDays.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ \? \* MON-FRI \*/)) {
            this.activeTab = 'daily';
            this.state.daily.subTab = 'everyWeekDay';
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.daily.everyWeekDay.hours = this.getAmPmHour(parsedHours);
            this.state.daily.everyWeekDay.hourType = this.getHourType(parsedHours);
            this.state.daily.everyWeekDay.minutes = Number(minutes);
            this.state.daily.everyWeekDay.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ \? \* (MON|TUE|WED|THU|FRI|SAT|SUN)(,(MON|TUE|WED|THU|FRI|SAT|SUN))* \*/)) {
            this.activeTab = 'weekly';
            this.selectOptions.days.forEach(weekDay => this.state.weekly[weekDay] = false);
            dayOfWeek.split(',').forEach(weekDay => this.state.weekly[weekDay] = true);
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.weekly.hours = this.getAmPmHour(parsedHours);
            this.state.weekly.hourType = this.getHourType(parsedHours);
            this.state.weekly.minutes = Number(minutes);
            this.state.weekly.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ (\d+|L|LW|1W) 1\/\d+ \? \*/)) {
            this.activeTab = 'monthly';
            this.state.monthly.subTab = 'specificDay';
            if (dayOfMonth.indexOf('W') !== -1) {
                this.state.monthly.specificDay.day = dayOfMonth.charAt(0);
                this.state.monthly.runOnWeekday = true;
            }
            else {
                this.state.monthly.specificDay.day = dayOfMonth;
            }
            this.state.monthly.specificDay.months = Number(month.substring(2));
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.monthly.specificDay.hours = this.getAmPmHour(parsedHours);
            this.state.monthly.specificDay.hourType = this.getHourType(parsedHours);
            this.state.monthly.specificDay.minutes = Number(minutes);
            this.state.monthly.specificDay.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ \? \d+\/\d+ (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
            /** @type {?} */
            const day = dayOfWeek.substr(0, 3);
            /** @type {?} */
            const monthWeek = dayOfWeek.substr(3);
            this.activeTab = 'monthly';
            this.state.monthly.subTab = 'specificWeekDay';
            this.state.monthly.specificWeekDay.monthWeek = monthWeek;
            this.state.monthly.specificWeekDay.day = day;
            if (month.indexOf('/') !== -1) {
                const [startMonth, months] = month.split('/').map(Number);
                this.state.monthly.specificWeekDay.months = months;
                this.state.monthly.specificWeekDay.startMonth = startMonth;
            }
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.monthly.specificWeekDay.hours = this.getAmPmHour(parsedHours);
            this.state.monthly.specificWeekDay.hourType = this.getHourType(parsedHours);
            this.state.monthly.specificWeekDay.minutes = Number(minutes);
            this.state.monthly.specificWeekDay.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ (\d+|L|LW|1W) \d+ \? \*/)) {
            this.activeTab = 'yearly';
            this.state.yearly.subTab = 'specificMonthDay';
            this.state.yearly.specificMonthDay.month = Number(month);
            if (dayOfMonth.indexOf('W') !== -1) {
                this.state.yearly.specificMonthDay.day = dayOfMonth.charAt(0);
                this.state.yearly.runOnWeekday = true;
            }
            else {
                this.state.yearly.specificMonthDay.day = dayOfMonth;
            }
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.yearly.specificMonthDay.hours = this.getAmPmHour(parsedHours);
            this.state.yearly.specificMonthDay.hourType = this.getHourType(parsedHours);
            this.state.yearly.specificMonthDay.minutes = Number(minutes);
            this.state.yearly.specificMonthDay.seconds = Number(seconds);
        }
        else if (cronSeven.match(/\d+ \d+ \d+ \? \d+ (MON|TUE|WED|THU|FRI|SAT|SUN)((#[1-5])|L) \*/)) {
            /** @type {?} */
            const day = dayOfWeek.substr(0, 3);
            /** @type {?} */
            const monthWeek = dayOfWeek.substr(3);
            this.activeTab = 'yearly';
            this.state.yearly.subTab = 'specificMonthWeek';
            this.state.yearly.specificMonthWeek.monthWeek = monthWeek;
            this.state.yearly.specificMonthWeek.day = day;
            this.state.yearly.specificMonthWeek.month = Number(month);
            /** @type {?} */
            const parsedHours = Number(hours);
            this.state.yearly.specificMonthWeek.hours = this.getAmPmHour(parsedHours);
            this.state.yearly.specificMonthWeek.hourType = this.getHourType(parsedHours);
            this.state.yearly.specificMonthWeek.minutes = Number(minutes);
            this.state.yearly.specificMonthWeek.seconds = Number(seconds);
        }
        else {
            this.activeTab = 'advanced';
            this.state.advanced.expression = cron;
        }
    }
    /**
     * @private
     * @param {?} cron
     * @return {?}
     */
    validate(cron) {
        this.state.validation.isValid = false;
        this.state.validation.errorMessage = '';
        if (!cron) {
            this.state.validation.errorMessage = 'Cron expression cannot be null';
            return;
        }
        /** @type {?} */
        const cronParts = cron.split(' ');
        /** @type {?} */
        let expected = 5;
        if (!this.options.removeSeconds) {
            expected++;
        }
        if (!this.options.removeYears) {
            expected++;
        }
        if (cronParts.length !== expected) {
            this.state.validation.errorMessage = `Invalid cron expression, there must be ${expected} segments`;
            return;
        }
        this.state.validation.isValid = true;
        return;
    }
    /**
     * @private
     * @return {?}
     */
    getDefaultAdvancedCronExpression() {
        if (this.options.removeSeconds && !this.options.removeYears) {
            return '15 10 L-2 * ? 2019';
        }
        if (!this.options.removeSeconds && this.options.removeYears) {
            return '0 15 10 L-2 * ?';
        }
        if (this.options.removeSeconds && this.options.removeYears) {
            return '15 10 L-2 * ?';
        }
        return '0 15 10 L-2 * ? 2019';
    }
    /**
     * @private
     * @return {?}
     */
    getDefaultState() {
        const [defaultHours, defaultMinutes, defaultSeconds] = this.options.defaultTime.split(':').map(Number);
        return {
            minutes: {
                minutes: 1,
                seconds: 0
            },
            hourly: {
                hours: 1,
                minutes: 0,
                seconds: 0
            },
            daily: {
                subTab: 'everyDays',
                everyDays: {
                    days: 1,
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                },
                everyWeekDay: {
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                }
            },
            weekly: {
                MON: true,
                TUE: false,
                WED: false,
                THU: false,
                FRI: false,
                SAT: false,
                SUN: false,
                hours: this.getAmPmHour(defaultHours),
                minutes: defaultMinutes,
                seconds: defaultSeconds,
                hourType: this.getHourType(defaultHours)
            },
            monthly: {
                subTab: 'specificDay',
                runOnWeekday: false,
                specificDay: {
                    day: '1',
                    months: 1,
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                },
                specificWeekDay: {
                    monthWeek: '#1',
                    day: 'MON',
                    startMonth: 1,
                    months: 1,
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                }
            },
            yearly: {
                subTab: 'specificMonthDay',
                runOnWeekday: false,
                specificMonthDay: {
                    month: 1,
                    day: '1',
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                },
                specificMonthWeek: {
                    monthWeek: '#1',
                    day: 'MON',
                    month: 1,
                    hours: this.getAmPmHour(defaultHours),
                    minutes: defaultMinutes,
                    seconds: defaultSeconds,
                    hourType: this.getHourType(defaultHours)
                }
            },
            advanced: {
                expression: this.getDefaultAdvancedCronExpression()
            },
            validation: {
                isValid: true,
                errorMessage: ''
            }
        };
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    getOrdinalSuffix(value) {
        if (value.length > 1) {
            /** @type {?} */
            const secondToLastDigit = value.charAt(value.length - 2);
            if (secondToLastDigit === '1') {
                return 'th';
            }
        }
        /** @type {?} */
        const lastDigit = value.charAt(value.length - 1);
        switch (lastDigit) {
            case '1':
                return 'st';
            case '2':
                return 'nd';
            case '3':
                return 'rd';
            default:
                return 'th';
        }
    }
    /**
     * @private
     * @return {?}
     */
    getSelectOptions() {
        return {
            months: Utils.getRange(1, 12),
            monthWeeks: ['#1', '#2', '#3', '#4', '#5', 'L'],
            days: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
            minutes: Utils.getRange(0, 59),
            fullMinutes: Utils.getRange(0, 59),
            seconds: Utils.getRange(0, 59),
            hours: Utils.getRange(1, 23),
            monthDays: Utils.getRange(1, 31),
            monthDaysWithLasts: [...Utils.getRange(1, 31).map(String), 'L'],
            hourTypes: ['AM', 'PM']
        };
    }
}
CronEditorComponent.ɵfac = function CronEditorComponent_Factory(t) { return new (t || CronEditorComponent)(); };
CronEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CronEditorComponent, selectors: [["cron-editor"]], inputs: { cron: "cron", disabled: "disabled", options: "options" }, outputs: { cronChange: "cronChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 20, vars: 15, consts: [["role", "tablist", 1, "nav", "nav-tabs", "tab-nav"], [3, "ngClass", 4, "ngIf"], ["role", "presentation", 3, "ngClass", 4, "ngIf"], [1, "cron-editor-container"], [1, "row"], [1, "col-xs-12"], [1, "tab-content"], ["class", "tab-pane", 3, "ngClass", 4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "ngClass"], ["aria-controls", "minutes", "role", "tab", "data-toggle", "tab", 3, "click"], ["role", "presentation", 3, "ngClass"], ["aria-controls", "hourly", "role", "tab", "data-toggle", "tab", 3, "click"], ["aria-controls", "daily", "role", "tab", "data-toggle", "tab", 3, "click"], ["aria-controls", "weekly", "role", "tab", "data-toggle", "tab", 3, "click"], ["aria-controls", "monthly", "role", "tab", "data-toggle", "tab", 3, "click"], ["aria-controls", "yearly", "role", "tab", "data-toggle", "tab", 3, "click"], ["aria-controls", "advanced", "role", "tab", "data-toggle", "tab", 3, "click"], [1, "tab-pane", 3, "ngClass"], [1, "well", "well-small"], [1, "minutes", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "seconds", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange", 4, "ngIf"], [3, "ngValue"], [1, "seconds", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "hours", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "radio", "name", "daily-radio", "value", "everyDays", "value", "everyDays", "checked", "checked", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "days", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [3, "disabled", "time", "selectClass", "use24HourTime", "hideSeconds", "change", "timeChange"], ["type", "radio", "name", "daily-radio", "value", "everyWeekDay", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "col-sm-6"], [1, "advanced-cron-editor-label"], ["type", "checkbox", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "radio", "name", "monthly-radio", "value", "specificDay", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "month-days", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "months-small", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "radio", "name", "monthly-radio", "value", "specificWeekDay", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "day-order-in-month", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "week-days", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], [1, "months", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "radio", "name", "yearly-radio", "value", "specificMonthDay", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "checkbox", 3, "ngModel", "ngClass", "change", "ngModelChange"], ["type", "radio", "name", "yearly-radio", "value", "specificMonthWeek", 3, "disabled", "ngModel", "ngClass", "change", "ngModelChange"], ["type", "text", "ng-disabled", "disabled || activeTab !== 'advanced'", 1, "advanced-cron-editor-input", 3, "ngModel", "ngClass", "change", "ngModelChange"]], template: function CronEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, CronEditorComponent_li_1_Template, 3, 3, "li", 1);
        ɵngcc0.ɵɵtemplate(2, CronEditorComponent_li_2_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵtemplate(3, CronEditorComponent_li_3_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵtemplate(4, CronEditorComponent_li_4_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵtemplate(5, CronEditorComponent_li_5_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵtemplate(6, CronEditorComponent_li_6_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵtemplate(7, CronEditorComponent_li_7_Template, 3, 3, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 3)(9, "div", 4)(10, "div", 5)(11, "div", 6);
        ɵngcc0.ɵɵtemplate(12, CronEditorComponent_div_12_Template, 8, 9, "div", 7);
        ɵngcc0.ɵɵtemplate(13, CronEditorComponent_div_13_Template, 10, 13, "div", 7);
        ɵngcc0.ɵɵtemplate(14, CronEditorComponent_div_14_Template, 12, 25, "div", 7);
        ɵngcc0.ɵɵtemplate(15, CronEditorComponent_div_15_Template, 35, 29, "div", 7);
        ɵngcc0.ɵɵtemplate(16, CronEditorComponent_div_16_Template, 30, 46, "div", 7);
        ɵngcc0.ɵɵtemplate(17, CronEditorComponent_div_17_Template, 27, 41, "div", 7);
        ɵngcc0.ɵɵtemplate(18, CronEditorComponent_div_18_Template, 3, 5, "div", 7);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(19, CronEditorComponent_div_19_Template, 3, 1, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideMinutesTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideHourlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideDailyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideWeeklyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideMonthlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideYearlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideAdvancedTab);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideMinutesTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideHourlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideDailyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideWeeklyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideMonthlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideYearlyTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.hideAdvancedTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.state.validation.isValid);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.NgSelectOption, ɵngcc2.ɵNgSelectMultipleOption, ɵngcc2.DefaultValueAccessor, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.SelectControlValueAccessor, ɵngcc2.RadioControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, TimePickerComponent]; }, styles: [".cron-editor-container[_ngcontent-%COMP%]{margin-top:10px}.cron-editor-container[_ngcontent-%COMP%]   .cron-editor-radio[_ngcontent-%COMP%]{width:20px;display:inline-block}.cron-editor-container[_ngcontent-%COMP%]   .cron-editor-checkbox[_ngcontent-%COMP%], .cron-editor-container[_ngcontent-%COMP%]   .cron-editor-input[_ngcontent-%COMP%], .cron-editor-container[_ngcontent-%COMP%]   .cron-editor-select[_ngcontent-%COMP%]{display:inline-block}.cron-editor-container[_ngcontent-%COMP%]   .well-time-wrapper[_ngcontent-%COMP%]{padding-left:20px}.cron-editor-container[_ngcontent-%COMP%]   .inline-block[_ngcontent-%COMP%]{display:inline-block}.cron-editor-container[_ngcontent-%COMP%]   .days[_ngcontent-%COMP%], .cron-editor-container[_ngcontent-%COMP%]   .hours[_ngcontent-%COMP%], .cron-editor-container[_ngcontent-%COMP%]   .minutes[_ngcontent-%COMP%], .cron-editor-container[_ngcontent-%COMP%]   .seconds[_ngcontent-%COMP%]{width:70px}.cron-editor-container[_ngcontent-%COMP%]   .months[_ngcontent-%COMP%]{width:120px}.cron-editor-container[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]{width:130px}.cron-editor-container[_ngcontent-%COMP%]   .months-small[_ngcontent-%COMP%]{width:60px}.cron-editor-container[_ngcontent-%COMP%]   .day-order-in-month[_ngcontent-%COMP%]{width:95px}.cron-editor-container[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]{width:120px}.cron-editor-container[_ngcontent-%COMP%]   .advanced-cron-editor-input[_ngcontent-%COMP%]{width:200px}.cron-editor-container[_ngcontent-%COMP%]   .hour-types[_ngcontent-%COMP%]{width:70px}.cron-editor-container[_ngcontent-%COMP%]   .advanced-cron-editor-label[_ngcontent-%COMP%]{font-weight:200}.nav-tabs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer}.form-control[_ngcontent-%COMP%]{height:auto}"] });
CronEditorComponent.propDecorators = {
    disabled: [{ type: Input }],
    options: [{ type: Input }],
    cron: [{ type: Input }],
    cronChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CronEditorComponent, [{
        type: Component,
        args: [{ selector: 'cron-editor', template: "<!-- Tabs -->\r\n<ul class=\"nav nav-tabs tab-nav\" role=\"tablist\">\r\n    <li [ngClass]=\"{'active': activeTab === 'minutes'}\" *ngIf=\"!options.hideMinutesTab\">\r\n        <a aria-controls=\"minutes\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('minutes')\">\r\n            Minutes\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideHourlyTab\" [ngClass]=\"{'active': activeTab === 'hourly'}\">\r\n        <a aria-controls=\"hourly\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('hourly')\">\r\n            Hourly\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideDailyTab\" [ngClass]=\"{'active': activeTab === 'daily'}\">\r\n        <a aria-controls=\"daily\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('daily')\">\r\n            Daily\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideWeeklyTab\" [ngClass]=\"{'active': activeTab === 'weekly'}\">\r\n        <a aria-controls=\"weekly\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('weekly')\">\r\n            Weekly\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideMonthlyTab\" [ngClass]=\"{'active': activeTab === 'monthly'}\">\r\n        <a aria-controls=\"monthly\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('monthly')\">\r\n            Monthly\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideYearlyTab\" [ngClass]=\"{'active': activeTab === 'yearly'}\">\r\n        <a aria-controls=\"yearly\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('yearly')\">\r\n            Yearly\r\n        </a>\r\n    </li>\r\n\r\n    <li role=\"presentation\" *ngIf=\"!options.hideAdvancedTab\" [ngClass]=\"{'active': activeTab === 'advanced'}\">\r\n        <a aria-controls=\"advanced\" role=\"tab\" data-toggle=\"tab\" (click)=\"setActiveTab('advanced')\">\r\n            Advanced\r\n        </a>\r\n    </li>\r\n</ul>\r\n\r\n<!-- Tab content -->\r\n<div class=\"cron-editor-container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"tab-content\">\r\n                <!-- Minutes-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideMinutesTab\" [ngClass]=\"{'active': activeTab === 'minutes'}\">\r\n                    <div class=\"well well-small\">\r\n                        Every\r\n                        <select class=\"minutes\" [disabled]=\"disabled || activeTab !== 'minutes'\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.minutes.minutes\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let minute of selectOptions.minutes\" [ngValue]=\"minute\">\r\n                                {{minute}}\r\n                            </option>\r\n                        </select> minute(s)\r\n                        <span *ngIf=\"!options.hideSeconds\">on second</span>\r\n                        <select class=\"seconds\" *ngIf=\"!options.hideSeconds\" [disabled]=\"disabled || activeTab !== 'minutes'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.minutes.seconds\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let second of selectOptions.seconds\" [ngValue]=\"second\">\r\n                                {{second}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Hourly-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideHourlyTab\" [ngClass]=\"{'active': activeTab === 'hourly'}\">\r\n                    <div class=\"well well-small\">\r\n                        Every\r\n                        <select class=\"hours\" [disabled]=\"disabled || activeTab !== 'hourly'\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.hourly.hours\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let hour of selectOptions.hours\" [ngValue]=\"hour\">\r\n                                {{hour}}\r\n                            </option>\r\n                        </select> hour(s) on minute\r\n                        <select class=\"minutes\" [disabled]=\"disabled || activeTab !== 'hourly'\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.hourly.minutes\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let minute of selectOptions.fullMinutes\" [ngValue]=\"minute\">\r\n                                {{minute}}\r\n                            </option>\r\n                        </select>\r\n                        <span *ngIf=\"!options.hideSeconds\">and second</span>\r\n                        <select class=\"seconds\" *ngIf=\"!options.hideSeconds\" [disabled]=\"disabled || activeTab !== 'hourly'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.hourly.seconds\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let second of selectOptions.seconds\" [ngValue]=\"second\">\r\n                                {{second}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Daily-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideDailyTab\" [ngClass]=\"{'active': activeTab === 'daily'}\">\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"daily-radio\" value=\"everyDays\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.daily.subTab\" value=\"everyDays\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.daily.subTab\" [ngClass]=\"state.formRadioClass\" checked=\"checked\">\r\n                        Every\r\n                        <select class=\"days\" [disabled]=\"disabled || activeTab !== 'daily' || state.daily.subTab !== 'everyDays'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.daily.everyDays.days\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let monthDay of selectOptions.monthDays\" [ngValue]=\"monthDay\">\r\n                                {{monthDay}}\r\n                            </option>\r\n                        </select> day(s) at\r\n\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'daily' || state.daily.subTab !== 'everyDays'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.daily.everyDays\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>\r\n                    </div>\r\n\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"daily-radio\" value=\"everyWeekDay\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.daily.subTab\" [ngClass]=\"state.formRadioClass\"> Every working day at\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'daily' || state.daily.subTab !== 'everyWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.daily.everyWeekDay\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Weekly-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideWeeklyTab\" [ngClass]=\"{'active': activeTab === 'weekly'}\">\r\n                    <div class=\"well well-small\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.MON\" [ngClass]=\"options.formCheckboxClass\"> Monday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.TUE\" [ngClass]=\"options.formCheckboxClass\"> Tuesday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.WED\" [ngClass]=\"options.formCheckboxClass\"> Wednesday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.THU\" [ngClass]=\"options.formCheckboxClass\"> Thursday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.FRI\" [ngClass]=\"options.formCheckboxClass\"> Friday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.SAT\" [ngClass]=\"options.formCheckboxClass\"> Saturday</label>\r\n                            </div>\r\n                            <div class=\"col-sm-6\">\r\n                                <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(ngModel)]=\"state.weekly.SUN\" [ngClass]=\"options.formCheckboxClass\"> Sunday</label>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-sm-6\">\r\n                                at\r\n                                <cron-time-picker [disabled]=\"disabled || activeTab !== 'weekly'\" (change)=\"regenerateCron()\"\r\n                                    [(time)]=\"state.weekly\" [selectClass]=\"options.formSelectClass\" [use24HourTime]=\"options.use24HourTime\"\r\n                                    [hideSeconds]=\"options.hideSeconds\">\r\n                                </cron-time-picker>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n                <!-- Monthly-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideMonthlyTab\" [ngClass]=\"{'active': activeTab === 'monthly'}\">\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"monthly-radio\" value=\"specificDay\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.monthly.subTab\" [ngClass]=\"state.formRadioClass\"> On the\r\n                        <select class=\"month-days\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificDay.day\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let monthDaysWithLast of selectOptions.monthDaysWithLasts\" [ngValue]=\"monthDaysWithLast\">\r\n                                {{monthDayDisplay(monthDaysWithLast)}}\r\n                            </option>\r\n                        </select> of every\r\n                        <select class=\"months-small\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificDay.months\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let month of selectOptions.months\" [ngValue]=\"month\">\r\n                                {{month}}\r\n                            </option>\r\n                        </select> month(s) at\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificDay'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.monthly.specificDay\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>&nbsp;\r\n                        <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificDay'\" \r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.runOnWeekday\" [ngClass]=\"options.formCheckboxClass\"> during the nearest weekday</label>\r\n                    </div>\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"monthly-radio\" value=\"specificWeekDay\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.monthly.subTab\" [ngClass]=\"state.formRadioClass\">\r\n                        On the\r\n                        <select class=\"day-order-in-month\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificWeekDay.monthWeek\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let monthWeek of selectOptions.monthWeeks\" [ngValue]=\"monthWeek\">\r\n                                {{monthWeekDisplay(monthWeek)}}\r\n                            </option>\r\n                        </select>\r\n                        <select class=\"week-days\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificWeekDay.day\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let day of selectOptions.days\" [ngValue]=\"day\">\r\n                                {{dayDisplay(day)}}\r\n                            </option>\r\n                        </select> of every\r\n                        <select class=\"months-small\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificWeekDay.months\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let month of selectOptions.months\" [ngValue]=\"month\">\r\n                                {{month}}\r\n                            </option>\r\n                        </select> month(s) starting in\r\n                        <select class=\"months\" [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.monthly.specificWeekDay.startMonth\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let month of selectOptions.months\" [ngValue]=\"month\">\r\n                                {{monthDisplay(month)}}\r\n                            </option>\r\n                        </select>\r\n                        \r\n                        at\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'monthly' || state.monthly.subTab !== 'specificWeekDay'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.monthly.specificWeekDay\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Yearly-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideYearlyTab\" [ngClass]=\"{'active': activeTab === 'yearly'}\">\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"yearly-radio\" value=\"specificMonthDay\" [disabled]=\"disabled\" (change)=\"regenerateCron()\"\r\n                            [(ngModel)]=\"state.yearly.subTab\" [ngClass]=\"state.formRadioClass\">\r\n                        Every\r\n                        <select class=\"months\" [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.specificMonthDay.month\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let month of selectOptions.months\" [ngValue]=\"month\">\r\n                                {{monthDisplay(month)}}\r\n                            </option>\r\n                        </select> on the\r\n                        <select class=\"month-days\" [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthDay'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.specificMonthDay.day\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let monthDaysWithLast of selectOptions.monthDaysWithLasts\" [ngValue]=\"monthDaysWithLast\">\r\n                                {{monthDayDisplay(monthDaysWithLast)}}\r\n                            </option>\r\n                        </select> at\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthDay'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.yearly.specificMonthDay\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>&nbsp;\r\n                        <label class=\"advanced-cron-editor-label\"><input type=\"checkbox\" (change)=\"regenerateCron()\"\r\n                        [(ngModel)]=\"state.yearly.runOnWeekday\" [ngClass]=\"options.formCheckboxClass\"> during the nearest weekday</label>\r\n                    </div>\r\n                    <div class=\"well well-small\">\r\n                        <input type=\"radio\" name=\"yearly-radio\" value=\"specificMonthWeek\" [disabled]=\"disabled\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.subTab\" [ngClass]=\"state.formRadioClass\">\r\n                        On the\r\n                        <select class=\"day-order-in-month\" [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthWeek'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.specificMonthWeek.monthWeek\"\r\n                            [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let monthWeek of selectOptions.monthWeeks\" [ngValue]=\"monthWeek\">\r\n                                {{monthWeekDisplay(monthWeek)}}\r\n                            </option>\r\n                        </select>\r\n                        <select class=\"week-days\" [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthWeek'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.specificMonthWeek.day\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let day of selectOptions.days\" [ngValue]=\"day\">\r\n                                {{dayDisplay(day)}}\r\n                            </option>\r\n                        </select> of\r\n                        <select class=\"months\" [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthWeek'\"\r\n                            (change)=\"regenerateCron()\" [(ngModel)]=\"state.yearly.specificMonthWeek.month\" [ngClass]=\"options.formSelectClass\">\r\n                            <option *ngFor=\"let month of selectOptions.months\" [ngValue]=\"month\">\r\n                                {{monthDisplay(month)}}\r\n                            </option>\r\n                        </select> at\r\n                        <cron-time-picker [disabled]=\"disabled || activeTab !== 'yearly' || state.yearly.subTab !== 'specificMonthWeek'\"\r\n                            (change)=\"regenerateCron()\" [(time)]=\"state.yearly.specificMonthWeek\" [selectClass]=\"options.formSelectClass\"\r\n                            [use24HourTime]=\"options.use24HourTime\" [hideSeconds]=\"options.hideSeconds\">\r\n                        </cron-time-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- Advanced-->\r\n                <div class=\"tab-pane\" *ngIf=\"!options.hideAdvancedTab\" [ngClass]=\"{'active': activeTab === 'advanced'}\">\r\n                    Cron Expression\r\n                    <input type=\"text\" class=\"advanced-cron-editor-input\" ng-disabled=\"disabled || activeTab !== 'advanced'\"\r\n                        (change)=\"regenerateCron()\" [(ngModel)]=\"state.advanced.expression\" [ngClass]=\"options.formInputClass\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"!state.validation.isValid\">\r\n        <code>{{state.validation.errorMessage}}</code>\r\n    </div>\r\n</div>", styles: [".cron-editor-container{margin-top:10px}.cron-editor-container .cron-editor-radio{width:20px;display:inline-block}.cron-editor-container .cron-editor-checkbox,.cron-editor-container .cron-editor-input,.cron-editor-container .cron-editor-select{display:inline-block}.cron-editor-container .well-time-wrapper{padding-left:20px}.cron-editor-container .inline-block{display:inline-block}.cron-editor-container .days,.cron-editor-container .hours,.cron-editor-container .minutes,.cron-editor-container .seconds{width:70px}.cron-editor-container .months{width:120px}.cron-editor-container .month-days{width:130px}.cron-editor-container .months-small{width:60px}.cron-editor-container .day-order-in-month{width:95px}.cron-editor-container .week-days{width:120px}.cron-editor-container .advanced-cron-editor-input{width:200px}.cron-editor-container .hour-types{width:70px}.cron-editor-container .advanced-cron-editor-label{font-weight:200}.nav-tabs li a{cursor:pointer}.form-control{height:auto}"] }]
    }], function () { return []; }, { cronChange: [{
            type: Output
        }], cron: [{
            type: Input
        }], disabled: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TimePickerComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.hours = this.use24HourTime ? Utils.getRange(0, 23) : Utils.getRange(0, 12);
        this.minutes = Utils.getRange(0, 59);
        this.seconds = Utils.getRange(0, 59);
        this.hourTypes = ['AM', 'PM'];
    }
}
TimePickerComponent.ɵfac = function TimePickerComponent_Factory(t) { return new (t || TimePickerComponent)(); };
TimePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TimePickerComponent, selectors: [["cron-time-picker"]], inputs: { disabled: "disabled", time: "time", selectClass: "selectClass", use24HourTime: "use24HourTime", hideSeconds: "hideSeconds" }, outputs: { change: "change" }, decls: 6, vars: 10, consts: [[1, "timeFormControl", 3, "ngModel", "disabled", "ngClass", "change", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["class", "timeFormControl", 3, "ngModel", "disabled", "ngClass", "change", "ngModelChange", 4, "ngIf"], [3, "ngValue"]], template: function TimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("change", function TimePickerComponent_Template_select_change_0_listener() { return ctx.change.emit(); })("ngModelChange", function TimePickerComponent_Template_select_ngModelChange_0_listener($event) { return ctx.time.hours = $event; });
        ɵngcc0.ɵɵtemplate(1, TimePickerComponent_option_1_Template, 2, 2, "option", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "select", 0);
        ɵngcc0.ɵɵlistener("change", function TimePickerComponent_Template_select_change_2_listener() { return ctx.change.emit(); })("ngModelChange", function TimePickerComponent_Template_select_ngModelChange_2_listener($event) { return ctx.time.minutes = $event; });
        ɵngcc0.ɵɵtemplate(3, TimePickerComponent_option_3_Template, 2, 2, "option", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TimePickerComponent_select_4_Template, 2, 4, "select", 2);
        ɵngcc0.ɵɵtemplate(5, TimePickerComponent_select_5_Template, 2, 4, "select", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.time.hours)("disabled", ctx.disabled)("ngClass", ctx.selectClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hours);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.time.minutes)("disabled", ctx.disabled)("ngClass", ctx.selectClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.minutes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideSeconds);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.use24HourTime);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.NgSelectOption, ɵngcc2.ɵNgSelectMultipleOption, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: [".timeFormControl[_ngcontent-%COMP%]{width:70px;display:inline}"] });
TimePickerComponent.propDecorators = {
    change: [{ type: Output }],
    disabled: [{ type: Input }],
    time: [{ type: Input }],
    selectClass: [{ type: Input }],
    use24HourTime: [{ type: Input }],
    hideSeconds: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimePickerComponent, [{
        type: Component,
        args: [{ selector: 'cron-time-picker', template: "<!-- hour -->\r\n<select class=\"timeFormControl\" (change)=\"change.emit()\" [(ngModel)]=\"time.hours\" [disabled]=\"disabled\" [ngClass]=\"selectClass\">\r\n  <option *ngFor=\"let hour of hours\" [ngValue]=\"hour\">{{hour}}</option>\r\n</select>\r\n\r\n<!-- minute -->\r\n<select class=\"timeFormControl\" (change)=\"change.emit()\" [(ngModel)]=\"time.minutes\" [disabled]=\"disabled\" [ngClass]=\"selectClass\">\r\n  <option *ngFor=\"let minute of minutes\" [ngValue]=\"minute\">{{minute}}</option>\r\n</select>\r\n\r\n<!-- second -->\r\n<select class=\"timeFormControl\" (change)=\"change.emit()\" [(ngModel)]=\"time.seconds\" [disabled]=\"disabled\" *ngIf=\"!hideSeconds\"\r\n  [ngClass]=\"selectClass\">\r\n  <option *ngFor=\"let second of seconds\" [ngValue]=\"second\">{{second}}</option>\r\n</select>\r\n\r\n<!-- am/pm -->\r\n<select class=\"timeFormControl\" (change)=\"change.emit()\" [(ngModel)]=\"time.hourTypes\" [disabled]=\"disabled\" *ngIf=\"!use24HourTime\"\r\n  [ngClass]=\"selectClass\">\r\n  <option *ngFor=\"let hourType of hourTypes\" [ngValue]=\"hourType\">{{hourType}}</option>\r\n</select>", styles: [".timeFormControl{width:70px;display:inline}"] }]
    }], function () { return []; }, { change: [{
            type: Output
        }], disabled: [{
            type: Input
        }], time: [{
            type: Input
        }], selectClass: [{
            type: Input
        }], use24HourTime: [{
            type: Input
        }], hideSeconds: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CronEditorModule {
}
CronEditorModule.ɵfac = function CronEditorModule_Factory(t) { return new (t || CronEditorModule)(); };
CronEditorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CronEditorModule });
CronEditorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CronEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [CronEditorComponent, TimePickerComponent],
                imports: [CommonModule, FormsModule],
                exports: [CronEditorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CronEditorModule, { declarations: function () { return [CronEditorComponent, TimePickerComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [CronEditorComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CronEditorComponent, CronEditorModule, TimePickerComponent as ɵa };

